const isMobilePlansView = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(max-width: 767px)")?.matches ||
    window.innerWidth <= 767);

const PlanDetailsView = () =>
  isMobilePlansView()
    ? import(
        /*webpackChunkName: "PlanDetailsViewMobile"*/ "../../../views/sales/PlanDetailsViewMobile.vue"
      )
    : import(
        /*webpackChunkName: "PlanDetailsView"*/ "../../../views/sales/PlanDetailsView.vue"
      );
export default {
  path: "plans",
  name: "plans",
  alias: ["planes"],
  component: PlanDetailsView,
  meta: {
    requiresAuth: false,
    requiresEntitlement: false,
  },
};
